import { render, staticRenderFns } from "./IncomingEventsModal.vue?vue&type=template&id=064d7b28"
import script from "./IncomingEventsModal.vue?vue&type=script&lang=js"
export * from "./IncomingEventsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports